module.exports = __webpack_public_path__ + "static/Spalona_Ziemia-59ae01d26b26e4503c3790e121365d7f.jpeg";